<template>
    <div class="body-padding order-detail" style="overflow: scroll; -webkit-overflow-scrolling: touch;">
        <div class="order-detail__info">
            <div class="info-flex info-padding info-title">
                <span>订单信息</span>
                <van-button
                        class="follow-btn"
                        type="warning"
                        size="small"
                        @click.stop="clickLogistics"
                >物流跟踪
                </van-button>
            </div>
            <div class="info-flex info-padding info-content">
                <span>订单号：</span>
                <span>{{ detail.orderNumber }}
                        <van-icon
                                v-show="detail.orderNumber"
                                class="btn-copy"
                                name="description"
                                @click.stop="handleCopyClick(detail.orderNumber, '订单号')"
                                size="0.4rem"></van-icon>
                </span>
            </div>
            <div class="info-flex info-padding info-content">
                <span>下单时间：</span>
                <span>{{ detail.createDate }}</span>
            </div>
            <div class="info-flex info-padding info-content">
                <span>运单号：</span>
                <span>{{ detail.trackingNumber }}
                <van-icon
                        v-show="detail.trackingNumber"
                        class="btn-copy"
                        name="description"
                        @click.stop="handleCopyClick(detail.trackingNumber, '运单号')"
                        size="0.4rem"></van-icon>
                </span>
            </div>
            <div class="info-flex info-padding info-content">
                <span style="font-weight: bold;color:#042D6F;">订单状态：</span>
                <span style="font-weight: bold;color:#042D6F;">{{ detail.statusName }}</span>
            </div>
            <!-- 寄收货人 -->
            <address-item :detail="detail" :showAddress="false"></address-item>
 
        </div>

        <div class="order-detail__goods">
            <van-collapse v-model="activeName">
                <van-collapse-item title="货物信息" name="1">
                    <div class="service-item">                        
                        <span>重量：{{ detail.weight }}kg</span>
                        <span>件数：{{ detail.goodsNumber }}</span>
                    </div>
                    <div class="service-item">
                        <span>基础运费：{{ detail.freight ? detail.freight : '-' }}元</span>
                        <span></span>
                    </div>
                    <div class="service-item">
                        <span>预计计佣：{{ detail.commission ? detail.commission : '-' }}元</span>
                        <span></span>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>

    </div>
</template>

<script>
    import {Toast} from 'vant'

    export default {
        name: "InviteOrderDetail",
        components: {
            AddressItem: () => import('./components/AddressItem'),
            QRcode: () => import ('./components/QRcode'),
            OrganList: () => import ('../../components/OrganList')
        },
        data() {
            return {
                id: this.$route.query.id,
                detail: {
                    orderInfoList:[]
                },
                activeName: ['1'],
                service: "",                
                city: {
                    provinceName: '',
                    provinceId: '',
                    cityName: '',
                    cityId: '',
                    districtName: '',
                    districtId: '',
                    organId: '',
                    organName: '',
                    address: ''
                },
                organVisible: false,
                isPush: this.$route.name === 'PushOrderDetail',
                isQRcode: false
            }
        },
        created() {         
            this.getDetail();
        },
        mounted() {
            this.service = this.$route.query.service
        },
        methods: {
            isQRcods() {
                this.isQRcode = false
            },
            concatCustomer() {

            },           
            // 获取数据
            getDetail() {
                let params = {
                    params: this.id
                };
                this.$axios.post('merchant/getOrderBriefInfo', params).then(res => {
                    if (res.data.code === 200) {
                        this.detail = res.data.data;
                    }
                });
            },
            // 物流跟踪
            clickLogistics() {
                this.$router.push("/search/logistics/" + this.detail.orderNumber);
            },
            handleCopyClick(text, tip) {
                this.$copyText(text).then(
                    () => {
                        Toast({
                            message: tip + "复制成功！",
                            duration: 1000
                        });
                    },
                    () => {
                        Toast({
                            message: tip + "复制失败！",
                            duration: 1000
                        });
                    }
                );
            }            
        }
    }
</script>


<style lang="scss">
    .order-detail {
        .order-detail__info {
            background-color: #fff;
            margin-bottom: 0.13rem;

            .info-flex {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            .info-padding {
                padding-left: 0.31rem;
                padding-right: 0.31rem;
            }

            .info-title {
                font-size: 0.4rem;
                color: #2D2D2D;
                height: 1.07rem;
                border-bottom: 1px solid #E5E5E5;
            }

            .info-content {
                font-size: 0.37rem;
                color: #4F4F4F;
                height: 0.67rem;
            }

            .info-service {
                padding-top: 0.23rem;
                font-size: 0.37rem;
                color: #4F4F4F;
            }

            .order-detail__service {
                border-top: 1px solid #E5E5E5;
            }

            .order-detail__concat {
                margin-top: 0.23rem;
                border-top: 1px solid #E5E5E5;
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 0.93rem;
                font-size: 0.37rem;
                color: #4F4F4F;

                .concat-customer {
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    justify-content: center;
                    border-right: 1px solid #D0D0D0;
                }

                .concat-reminder {
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    justify-content: center;
                }

                .icon-concat {
                    margin-right: 0.31rem;
                    transform: translateY(-1px);
                    display: inline-block;
                    background: url("../../assets/concat.png") center/100% no-repeat;
                    width: 0.53rem;
                    height: 0.53rem;
                }

                .icon-reminder {
                    margin-right: 0.31rem;
                    transform: translateY(-1px);
                    display: inline-block;
                    background: url("../../assets/reminder.png") center/100% no-repeat;
                    width: 0.52rem;
                    height: 0.6rem;
                }
            }
        }

        .order-detail__goods {
            margin-bottom: 0.13rem;

            .service-item {
                padding: 0.2rem 0.31rem 0.2rem 0.31rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                font-size: 0.37rem;
                color: #4F4F4F;
            }
        }

        .order-detail__pay {
            margin-bottom: 0.13rem;

            .pay-item {
                padding: 0.2rem 0.31rem 0.2rem 0.31rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                font-size: 0.37rem;
                color: #4F4F4F;
            }
        }

        .order-detail__btn {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            background-color: #fff;
            height: 3.55rem;

            .submit-btn {
                width: 4rem;
                height: 1.07rem;
                line-height: 1.07rem;
            }
        }

        .follow-btn {
            width: 1.87rem;
            height: 0.64rem;
            line-height: 0.64rem;
            border-radius: 0;
        }

        .btn-copy {
            -webkit-transform: translateY(2px);
            -moz-transform: translateY(2px);
            -ms-transform: translateY(2px);
            -o-transform: translateY(2px);
            transform: translateY(2px);
            margin-left: 0.1rem;
            color: #FE9329;
        }

        .van-cell__left-icon, .van-cell__right-icon {
            display: none;
        }

        .van-collapse-item__content {
            border-top: 1px solid #E5E5E5;
            background-color: #fff;
        }
    }
</style>
